/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  icon: string,
};

const TicketButtonWrapper = glamorous.div(
  ({ theme }) => ({
    minWidth: 120,
    [theme.mediaQuery.tabletLandscapeAndBelow]: {
      paddingRight: theme.spacing.small,
    },
    [theme.mediaQuery.mobileOnly]: {
      minWidth: 78,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& > img': {
        width: '78px',
      },
      paddingLeft: theme.spacing.xsmall,
      paddingRight: theme.spacing.xsmall,
    },
  }),
);

const TicketImage = glamorous.img({
  height: 38,
});

const GoldTicketButton = ({ icon }: Props) => (
  <TicketButtonWrapper>
    <TicketImage src={icon} alt="" />
  </TicketButtonWrapper>
);

export default React.memo(GoldTicketButton);
